import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Modal, Select, Space, Switch, Upload, Image, TimePicker } from 'antd';
import { MinusCircleOutlined, PlusOutlined, UploadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { menuItems } from "../../fifthUtils/constant";
import { assignLanguage } from "../../utils/helpers";
import { useSelector } from "react-redux";
import bgImg from "../../fifthAssets/Images/kneeCentreBannerImg.jpeg"
import kneeCentreHeadingImg from "../../fifthAssets/Images/kneeCentreHeadingImg.jpeg"
import kneeCentreDesImg from "../../fifthAssets/Images/kneeCentreDesImg.jpeg"
import kneeCentrePointImg from "../../fifthAssets/Images/kneeCentrePointImg.jpeg"
const { Option } = Select

const ContentFormKneeCentre = ({ path, setPath, props }) => {
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = assignLanguage(language?.language)
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [form] = Form.useForm()
    const handleChange = (value) => {
        setPath(value);
        console.log('value', value)
    };
    const onFinish = async (values) => {
        let formData = new FormData()
        console.log('formData', values)

    }
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };
    return (
        <div className="main">
            <div className="content-form">
                <Form
                    initialValues={{ screen: path }}
                    form={form}
                    onFinish={onFinish}
                    layout='vertical'
                    requiredMark={true}
                >
                    <div className="content-form-logo-and-selectScreen-div">
                        <div>
                            <h2 className="content-form-heading">
                                {'Content Form Knee Centre of Expertise'}
                            </h2>
                        </div>
                        <div>
                            <Form.Item
                                name='screen'
                                label={selectedLanguage?.txt_select_screen}
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                            >
                                <Select
                                    showArrow
                                    showSearch
                                    allowClear
                                    placeholder={selectedLanguage?.txt_select_screen}
                                    optionFilterProp='children'
                                    filterOption={true}
                                    onChange={handleChange}
                                >
                                    {menuItems.slice(0, -2).map((item, index) => (
                                        <React.Fragment key={index}>
                                            <Option value={item.menuName}>
                                                {isELSelect ? item?.menuName : (isAlSelect ? item?.menuALName : item?.menuGLName)}
                                            </Option>
                                            {item.submenu ? item.submenu.map((sub, subIndex) => (
                                                <Option key={`${index}-${subIndex}`} value={sub.name} style={{ paddingLeft: '30px' }}>
                                                    {isELSelect ? sub?.name : (isAlSelect ? sub?.alName : sub?.glName)}
                                                </Option>
                                            )) : null}
                                        </React.Fragment>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="content_sections_div">
                        <h2>{selectedLanguage?.txt_add_banner_image}</h2>
                        <Form.Item
                            className="content-form-logo-div"
                            label={selectedLanguage?.txt_add_background_image}
                            name='bgImg'
                            valuePropName='fileList'
                            getValueFromEvent={normFile}
                        >
                            <Upload
                                maxCount={1}
                                accept='image/*'
                                name='logo'
                                action='/upload.do'
                                listType='picture'
                                beforeUpload={() => false}
                            >
                                <Button className="logo-upload-btn" icon={<UploadOutlined />}>{selectedLanguage?.txt_upload}</Button>
                            </Upload>
                        </Form.Item>
                        <Image
                            width={150}
                            src={bgImg}
                        />
                    </div>
                    <div className="content_sections_div">
                        <h2>
                            {selectedLanguage?.txt_knee_expertise_section}
                        </h2>
                        <Form.List name='pediatricRehabilitationItem' initialValue={[{ heading: null, description: null }]}>
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ key, name, ...restField }) => (
                                        <Space
                                            className="formList-main"
                                            key={key}
                                            style={{
                                                display: 'flex',
                                                marginBottom: 8,
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            <Form.Item
                                                className="content_inputs"
                                                {...restField}
                                                name={[name, 'heading']}
                                                label={selectedLanguage?.heading_label}
                                            >
                                                <Input placeholder={selectedLanguage?.heading_label} />
                                            </Form.Item>
                                            <Image
                                                width={150}
                                                src={kneeCentreHeadingImg}
                                            />
                                            <Form.Item
                                                className="content_inputs"
                                                {...restField}
                                                name={[name, 'description']}
                                                label={selectedLanguage?.txt_description}
                                            >
                                                <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_description} />
                                            </Form.Item>
                                            <Image
                                                width={150}
                                                src={kneeCentreDesImg}
                                            />
                                            <Form.List name={[name, 'pediatricRehabilitationSubItem']} initialValue={[{ points: null }]}>
                                                {(subFields, { add: addSub, remove: removeSub }) => (
                                                    <>
                                                        {subFields.map(({ key: subKey, name: subName, ...subRestField }) => (
                                                            <Space className="formList-main" key={subKey} style={{ display: 'flex', marginBottom: 8, flexWrap: 'wrap' }}>
                                                                <Form.Item
                                                                    className="content-form-logo-div"
                                                                    {...subRestField}
                                                                    name={[subName, 'points']}
                                                                    label={selectedLanguage?.txt_add_points}
                                                                >
                                                                    <Input placeholder={selectedLanguage?.txt_add_points} />
                                                                </Form.Item>
                                                                <Image
                                                                    width={150}
                                                                    src={kneeCentrePointImg}
                                                                />
                                                                {subFields.length > 1 && (
                                                                    <MinusCircleOutlined onClick={() => removeSub(subName)} style={{ marginTop: 24 }} />
                                                                )}
                                                            </Space>
                                                        ))}
                                                        <Form.Item>
                                                            <Button type="dashed" onClick={() => addSub()} block icon={<PlusOutlined />}>
                                                                {selectedLanguage?.txt_add_sub_service}
                                                            </Button>
                                                        </Form.Item>
                                                    </>
                                                )}
                                            </Form.List>
                                            {fields.length > 1 ?
                                                <span style={name ? { marginTop: -25, position: 'absolute' } : {}}>
                                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                                </span>
                                                :
                                                null
                                            }
                                        </Space>
                                    ))}
                                    <Form.Item>
                                        <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                                            {selectedLanguage?.add_button_txt}
                                        </Button>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    </div>
                    <Form.Item
                        className="content_inputs"
                        name='remark'
                        label={selectedLanguage?.txt_remark}
                    >
                        <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_remark} />
                    </Form.Item>
                    <Form.Item >
                        <Button
                            htmlType='submit'
                            style={{ borderRadius: 4, width: '100%' }}
                            type='primary'
                        // loading={loading}
                        >
                            {selectedLanguage?.submit_button}
                        </Button>
                    </Form.Item>
                </Form>
            </div >
        </div >
    )
}

export default ContentFormKneeCentre